<div class="row">

  <div *ngIf="carregando" class="overlay">
    <img src="assets/img/loading1.gif" class="imagem">
  </div>

  <div id="print-section" style="width: 220mm; height: 310mm;" class="col-md-9">
      <pdf-viewer *ngIf="voucher" [src]="voucher" [render-text]="true" (error)="onError($event)" (page-rendered)="pageRendered($event)"></pdf-viewer>
  </div>

  <div class="col-md-3 mt-5">
    <!-- <button class="btn no-print btn-success btn-block" (click)="salvar()"> Salvar</button> -->
    <button class="btn no-print btn-success btn-block col-12 mb-3" (click)="imprimir()"> {{"Imprimir/Salvar" | translate}}</button>
    <button class="btn no-print btn-success btn-block col-12 mb-3" (click)="mostraForm = !mostraForm"> {{"Enviar" | translate}}</button>
    <button class="btn no-print btn-success btn-block col-12" (click)="VoucherEmHtml()"> {{'Voucher Para Cópia' | translate}}</button>

    <form *ngIf="mostraForm" class="form mt-4" #form="ngForm" novalidate (keydown.enter)="$event.preventDefault()">
      <div class="alert alert-danger" *ngIf="errors">
        <ul>
          <li *ngFor="let erro of errors">
            {{erro}}
          </li>
        </ul>
      </div>
      <div class="alert alert-success" *ngIf="success">
        <p>{{success}}</p>
      </div>
      <div class="form-group row mb-4">
        <div class="col-sm-12">
          <app-input label="E-mail">
            <input type="text" [disabled]="loadingEnvio" class="form-control full-width" [(ngModel)]="email"
              required="required" name="email" placeholder="{{'Informe o E-mail' | translate}}">
          </app-input>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-12">
          <button [disabled]="!form.valid" [hidden]="loadingEnvio" type="submit"
            class="btn btn-primary  btn-block" (click)="EnviarVoucher()">{{"Enviar Voucher" | translate}}</button>
        </div>
      </div>
    </form>

  </div>

</div>
